// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_gxE","importantInfo":"styles_importantInfo__1fV6o"};